import { render, staticRenderFns } from "./UserContactForm.vue?vue&type=template&id=8f936c36&scoped=true"
import script from "./UserContactForm.vue?vue&type=script&lang=ts"
export * from "./UserContactForm.vue?vue&type=script&lang=ts"
import style0 from "./UserContactForm.vue?vue&type=style&index=0&id=8f936c36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f936c36",
  null
  
)

export default component.exports